'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.changePopupType = changePopupType;
exports.addAllPopupType = addAllPopupType;
exports.closePopup = closePopup;

var _PopupType = require('../../helpers/PopupType');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var POPUP_TYPE = 'redux/popup/POPUP_TYPE';

var initialState = {
  type: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case POPUP_TYPE:
      return (0, _extends3.default)({}, state, {
        type: action.value
      });
    default:
      return state;
  }
}

function changePopupType(id) {
  var value = [id];
  return { type: POPUP_TYPE, value: value };
}

function addAllPopupType() {
  var value = (0, _keys2.default)(_PopupType.PopupId).map(function (key) {
    return _PopupType.PopupId[key];
  });
  return { type: POPUP_TYPE, value: value };
}

function closePopup() {
  return function (dispatch, getState) {
    var value = getState().popup.type.splice(1);
    dispatch({ type: POPUP_TYPE, value: value });
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/popup.js
// module id = 25
// module chunks = 0